export var MQB_CHANNEL_MAP = {
  weixin: 1,
  wxmoments: 8,
  qq: 4,
  qzone: 3,
  weibo: 11
};
export var MQB_SHARE_TYPE = {
  page: 0,
  pic: 1,
  text: 2
};
export var WEISHI_CHANNEL_MAP = {
  weixin: 'share2wx',
  wxmoments: 'share2timeLine',
  qq: 'share2qq',
  qzone: 'share2qz',
  weibo: 'share2weibo'
};
export var MUSIC_CHANNEL_MAP = {
  weixin: 'weixin',
  wxmoments: 'timeline',
  qq: 'qq',
  qzone: 'qzone',
  weibo: 'sina'
};
export var QQ_NEWS_CHANNEL_MAP = {
  weixin: 'wechatFriend',
  wxmoments: 'moments',
  qq: 'qqFriend',
  qzone: 'qzone',
  weibo: 'weibo'
};
export var SUPPORTED_APP = ['app', 'qqsports', 'qqbrowser', 'kidapp', 'weishi', 'qqnews', 'qqmusic'];
export var CHANNEL_CONFIG = {
  app: ['save', 'qq', 'qzone', 'weixin', 'wxmoments', 'doki', 'weibo'],
  qqbrowser: ['qq', 'qzone', 'weixinNoPwd', 'wxmomentsNoPwd', 'weibo'],
  qqsports: ['qq', 'qzone', 'weixinNoPwd', 'wxmomentsNoPwd', 'weibo'],
  weishi: ['qq', 'qzone', 'weixinNoPwd', 'wxmomentsNoPwd', 'weibo'],
  qqnews: ['qq', 'qzone', 'weixinNoPwd', 'wxmomentsNoPwd', 'weibo'],
  qqmusic: ['save', 'qq', 'qzone', 'weixinNoPwd', 'wxmomentsNoPwd', 'weibo'],
  kidappSupported: ['save', 'weixin', 'wxmoments'],
  kidapp: ['weixin', 'wxmoments']
};